import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { GameService } from './game-service.interface';

export const DataAccessGameService = new InjectionToken<GameService>(
  'GameService',
);

export interface GameServiceUseClass extends ClassSansProvider {
  useClass: Type<GameService>;
}

export interface GameServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => GameService;
}

export type GameServiceProvider = GameServiceUseFactory | GameServiceUseClass;

export function provideDataAccessGameService(config: GameServiceProvider) {
  return {
    provide: DataAccessGameService,
    ...config,
  };
}
